import React from 'react';
import { useTranslation } from 'react-i18next';
import { Target, Plus } from 'lucide-react';
import { Button } from '@/shared/components/ui/Button';

interface EmptyKeyResultsProps {
  onAddClick: () => void;
}

export const EmptyKeyResults: React.FC<EmptyKeyResultsProps> = ({
  onAddClick,
}) => {
  const { t } = useTranslation('goals');

  return (
    <div className="border border-border bg-white rounded-lg p-8 text-center">
      <div className="flex flex-col items-center gap-3">
        <div className="rounded-full bg-muted p-3">
          <Target className="h-6 w-6 text-muted-foreground" />
        </div>
        <div className="space-y-1">
          <p className="text-sm font-medium text-foreground">
            {t('noKeyResults')}
          </p>
          <p className="text-xs text-muted-foreground">
            {t('noKeyResultsDescription')}
          </p>
        </div>
        <Button
          type="button"
          variant="outline"
          size="sm"
          onClick={onAddClick}
          className="mt-2"
        >
          <Plus className="h-4 w-4 mr-2" />
          {t('addFirstKeyResult')}
        </Button>
      </div>
    </div>
  );
};
